import React, { PureComponent } from "react";
import Styles from "./myStatStyles.module.css";
import { Box, Divider, Grid, Paper } from "@mui/material";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, Label, AreaChart, Area, Text } from 'recharts';
import { useSelector } from "react-redux";
import moment from "moment";
import { Card } from "antd";
import { textAlign } from "@mui/system";

export default function ExpertvsCommunityStatsGraph() {
  const userState = useSelector((state) => state.user);
  const myStat = useSelector((state) => state.myStatsData);
  const CustomizedAxisLabel = (props) => {
    const { x, y, stroke, value } = props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} style={{ fontSize: "12px" }} textAnchor="end" fill="#666" transform="rotate(-35)">
          {Math.round(value)}
        </text>
      </g>
    );
  }
  class CustomizedAxisTick extends PureComponent {
    render() {
      const { x, y, stroke, payload } = this.props;

      return (
        <g transform={`translate(${x},${y})`}>
          <text style={{ fontSize: "12px" }} x={0} y={0} dy={7} textAnchor="center" fill="#666">
            {moment(payload.value).format('MMM DD')}
          </text>
        </g>
      );
    }
  }
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          {/* <p>{payload.map((data, ind) => {
            return (
              <>
                <div key={ind}>My Score:{Math.round(data.payload.expertScore)}</div>
                <div>Avg Exp Score:{Math.round(data.payload.averageExpertScore)}</div>
              </>
            )
          })}</p> */}
        </div>
      );
    }

    return null;
  };
  const formatXAxis = (tickFormat) => {
    return moment(tickFormat).format("MMM DD");
  };

  const headingColor = {
    color:'#2A364A'
  }

  


  return (<>
    <Grid  container spacing={2}>
      <Grid item xs={12} paddingRight="16px" paddingBottom="16px">
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={12} sm={12} lg={6} xl={6} sx={(theme)=>({[theme.breakpoints.only("sm,xs")]:{marginLeft:"auto",marginRight:"auto"}})}>
            <Card style={{textAlign:'center'}} title='Total Questions Answered' styles={{header:headingColor}}>
            <Box sx={{display:"flex",justifyContent:"center", paddingBlock:'10px',width:'100%'}}>
              <ResponsiveContainer width={'100%'} height={400}>
            <BarChart
              data={myStat.totalAnsweredTrend}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
              barGap={15}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis tick={<CustomizedAxisTick />} axisLine={true} style={{ fontSize: "12px" }} dataKey="week.weekStart" reversed={true} />
              <YAxis style={{ fontSize: "12px" }}>
                <Label style={{ fontWeight: "bold", fontSize: "14px" }} angle={-90} position="inside">Total Questions Answered</Label>
              </YAxis>
              <Tooltip label="Avg Questions answered" />
              <Legend wrapperStyle={{fontSize:'12px'}} />
              <Bar name="Expert Response Time" barSize={9} dataKey="expertResponseTime" fill="#fd7400">
              </Bar>
              <Bar barSize={9} name="Avg Response Time" dataKey="avgResponseTime" fill="green" />
            </BarChart>
            </ResponsiveContainer>
            </Box>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6} xl={6}>
            <Card style={{textAlign:'center'}} title='Expert Score' styles={{header:headingColor}}>
          <Box sx={{display:"flex",justifyContent:"center", paddingBlock:'10px',width:'100%'}}>
            <ResponsiveContainer width={'100%'} height={400}>
            <LineChart
              data={myStat.expertScoreTrend}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis style={{ fontSize: "12px" }} dataKey="week.weekStart" reversed={true}
              offset={0} 
                tick={<CustomizedAxisTick />}>
                <Label dy={10} value="Week" position="center"  style={{ fontWeight: "bold", fontSize: "14px" }} />
              </XAxis>
              <YAxis style={{ fontSize: "12px" }} axisLine={true} type="number" domain={[0, 10]} ticks={[0, 2.5, 5, 7.5, 10]}>
                <Label style={{ fontWeight: "bold", fontSize: "14px" }} angle={-90} position="inside">Expert Score</Label>
              </YAxis>
              <Tooltip formatter={(value, name, props) => Math.round(value)} />
              <Legend wrapperStyle={{fontSize:'12px'}} />
              <Line type="monotone" name="Expert Score" dataKey="expertScore" stroke="green" />
              <Line type="monotone" name="Average Expert Score" dataKey="averageExpertScore" stroke="#fd7400" />
            </LineChart>
            </ResponsiveContainer>
            </Box>
            </Card>
          </Grid>
        </Grid>
        <Grid justifyContent="center" container rowSpacing={2} columnSpacing={2} sx={{ paddingTop: "12px" }}>
          <Grid item xs={12} lg={6} xl={6}>
            <Card style={{textAlign:'center'}} title='SLA Compliance' styles={{header:headingColor}}>
            <Box sx={{display:"flex",justifyContent:"center", paddingBlock:'10px',width:'100%'}}>
              <ResponsiveContainer width={'100%'} height={400}>
            <LineChart data={myStat.slaComplianceTrend} margin={{ right: 25, top: 10 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis offset={0} tickFormatter={formatXAxis} style={{ fontSize: "12px" }} dataKey="week.weekStart" />
              <YAxis style={{ fontSize: "12px" }} domain={[0, 10]} ticks={[0, 2.5, 5, 7.5, 10]} />
              <Line type="monotone" name="Average Compliance" dataKey="averageCompliance" stroke="#8884d8" activeDot={{ r: 8 }} />
              <Line type="monotone" name="Expert Compliance" dataKey="expertCompliance" stroke="#82ca9d" />
              <Tooltip />
              <Legend wrapperStyle={{fontSize:'12px'}} />
            </LineChart>
            </ResponsiveContainer>
            </Box>
            </Card>
          </Grid>
          <Grid item xs={12} xl={6} lg={6}>
            <Card title='Response Time' style={{textAlign:'center'}} styles={{header:headingColor}}>
            <Box sx={{display:"flex",justifyContent:"center", paddingBlock:'10px',width:'100%'}}>
              <ResponsiveContainer width={'100%'} height={400}>
            <LineChart width={520} height={400} data={myStat.responseTimeTrend}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }} >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis reversed={true} dataKey="week.weekEnd" offset={0} tickFormatter={(tick) => formatXAxis(tick)} style={{ fontSize: "12px" }}>
                <Label dy={12} dx={10} value="Week" position="center" style={{ fontSize: "14px", fontWeight: "bold" }} />
              </XAxis>
              <YAxis style={{ fontSize: "12px" }} axisLine={true}>
                <Label value="Time" angle={-90} style={{ fontSize: "14px", fontWeight: "bold" }} />
              </YAxis>
              <Tooltip />
              <Legend wrapperStyle={{fontSize:'12px'}} />
              <Line type="monotone" name="Expert Response Time" dataKey="expertResponseTime" stroke="#fd7400" />
              <Line type="monotone" name="Avg Response Time" dataKey="avgResponseTime" stroke="green" />
            </LineChart>
            </ResponsiveContainer>
            </Box>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </>)
}